import { DefaultMenuItem, GetContextMenuItemsParams, MenuItemDef } from "ag-grid-community";
import { message } from "antd";
import { useCallback, useEffect, useRef } from "react";

export const useDeleteRow = (isEditMode: boolean) => {
  const isEditModeRef = useRef(isEditMode);

  useEffect(() => {
    isEditModeRef.current = isEditMode;
  }, [isEditMode]);

  const deleteRow = useCallback(
    (params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
      const filteredItems = params.defaultItems ?? [];
      if (!isEditModeRef.current) return filteredItems;

      const isGroup = params.node?.group;
      const deleteItem: MenuItemDef = {
        name: isGroup ? "Delete Group" : "Delete Row",
        icon: '<span style="color:#ff4d4f;font-size:20px;">🗑</span>',
        action: () => {
          if (!params.node) {
            message.warning("No selection");
            return;
          }
          if (params.node.group) {
            const allLeafChildren = params.node.allLeafChildren || [];
            if (!allLeafChildren.length) {
              message.warning("No rows inside group");
              return;
            }
            const rowsToDelete = allLeafChildren.map((node) => node.data);
            params.api.applyTransaction({ remove: rowsToDelete });
            message.success(`Deleted ${rowsToDelete.length} row(s) from group`);
          } else {
            if (!params.node.data) {
              message.warning("No row data");
              return;
            }
            params.api.applyTransaction({ remove: [params.node.data] });
            message.success("Row deleted");
          }
        },
      };

      return [deleteItem, ...filteredItems];
    },
    [],
  );

  return deleteRow;
};
